/**
 * A small helper to conditionally add elements to an
 * object via spread operators.
 *
 * @example
 * const object = Object.assign(
 *     ...insertObjectIf(true, {a: '123'}, {b: '456'}),
 *     ...insertObjectIf(false, {c: '789'}),
 *     {foo: 'bar'}
 * )
 * object == {
 *    a: '123',
 *    b: '456',
 *    foo: 'bar'
 * }
 *
 * @see {@link http://2ality.com/2017/04/conditional-literal-entries.html}
 *
 * @param {boolean} condition - The condition to be met
 * @param {Object} elements - The object entries to be added
 * @returns {Object[]} The resulting object
 */
export function insertObjectIf(condition, ...elements) {
    return condition ? elements : [{}]
}
